<template>
  <div class="home-page cg-page">
    <div class="login-content">
      <div class="pt10 disflex" style="justify-content: center;background:url(static/images/star.png) no-repeat center -70px;max-width:750px;height: 380px;background-size: cover;    align-items: flex-start;">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
      </div>
      <div class="landing-page">
        <div class="">
          <div class="home-prize" style="padding-top: 100px;">

          </div>
<!--          <div class="span fs33 ac mt30" style="width:50%;margin: 0 auto;">-->
<!--            {{$t('ladingpageTips')}}-->
<!--          </div>-->
          <div class="span fs33 ac mt30 app-en" style="width:50%;margin: 0 auto;">
            {{ msg }}
          </div>

          <div class="ac mt50">

            <button class="btn btn-blue btn-green0 mt50" style="min-width: 350px;"><span @click="goLogin">{{$t('subscribeNow')}}</span></button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'
export default {
  components:{
    Header,Dialog
  },
  data() {
    return {
      list:[],
      account:'',
      password:'',
      isShow:false,
      type:'daily',
      isEN:'bur',
      mobile:'',
      msg:'',
    }
  },
  created(){
    let msg = this.$route.query.msg
    if(msg){
      this.msg = msg
    }
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
  methods: {
    back(){
      this.$router.go(-1);
    },
    goLogin(){
      window.location.href = "http://he.gbgts.com/grabget/consent/page"
    },
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
</style>



// WEBPACK FOOTER //
// src/page/errors.vue